import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Layout, Row, Col, Card, Statistic, Tag } from "antd";
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  UsergroupAddOutlined,
  ShoppingCartOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import { Column } from "@ant-design/plots";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import "../assets/css/Home.css";
import { Outlet } from "react-router-dom";
import escudo from "../assets/img/escudo.png";
import useAutoLogout from "../useAutoLogout";
import Api from "../api/Api";
import NotificationCenter from "./NotificationCenter"; // ajuste o path




const { Content } = Layout;

const Home = () => {
  const [collapsed, setCollapsed] = useState(false);
    useAutoLogout();
    
  const toggleCollapsed = () => setCollapsed((prev) => !prev);

  // Dados fake para o gráfico de barras
  const chartData = [
    { mes: "Jan", valor: 38 },
    { mes: "Fev", valor: 52 },
    { mes: "Mar", valor: 61 },
    { mes: "Abr", valor: 45 },
    { mes: "Mai", valor: 72 },
    { mes: "Jun", valor: 80 },
  ];

  const chartConfig = {
    data: chartData,
    xField: "mes",
    yField: "valor",
    columnWidthRatio: 0.5,
    autoFit: true,
    color: "#0057D9",
    label: false,
    xAxis: {
      label: {
        style: {
          fill: "#ffffffb3",
          fontSize: 12,
        },
      },
    },
    yAxis: {
      label: {
        style: {
          fill: "#ffffffb3",
          fontSize: 12,
        },
      },
      grid: {
        line: {
          style: {
            stroke: "rgba(255,255,255,0.08)",
          },
        },
      },
    },
    tooltip: {
      showTitle: false,
    },
  };
 return (
  <>
    {/* Sino FORA do Layout — fixed funciona corretamente */}
 

    <Layout className="app-layout">
      <Sidebar collapsed={collapsed} />

      <Layout className="app-main">
        <Topbar collapsed={collapsed} onToggle={toggleCollapsed} />

        <Content className="app-content">
          <Outlet />
        </Content>

        <div style={{
          position: "fixed",
          bottom: "-70px",
          right: "-250px",
          width: "500px",
          height: "500px",
          backgroundImage: `url(${escudo})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "bottom right",
          zIndex: 1,
          opacity: 0.1,
          pointerEvents: "none"
        }} />
      </Layout>
    </Layout>
  </>
);
};

export default Home;
